import { useState } from "react";
import { faqs } from "@/mocks/portal";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12">
          <div className="lg:col-span-1">
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-primary-600">
              <i className="ri-question-line"></i>
              常见问题
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              关于这个入口，你可能想问
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              这里整理了读者最常提出的几个问题，若还有疑问，可通过页脚邮箱联系我们。
            </p>
          </div>

          <div className="lg:col-span-2 rounded-card border border-background-200 bg-background-50 divide-y divide-background-200">
            {faqs.map((item, index) => {
              const open = index === openIndex;
              return (
                <div key={item.q}>
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? -1 : index)}
                      aria-expanded={open}
                      className="w-full flex items-start justify-between gap-4 text-left px-5 md:px-6 py-4 md:py-5 cursor-pointer"
                    >
                      <span className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug">
                        {item.q}
                      </span>
                      <span
                        className={`mt-0.5 w-7 h-7 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                          open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                  </h3>
                  {open && (
                    <div className="px-5 md:px-6 pb-5 -mt-1">
                      <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}